<div class="page-container">
  <div *ngIf="isLoading">
    <app-loading></app-loading>
  </div>

  <h1 class="page-title">
    <ng-content select="[title]"></ng-content>
  </h1>

  <div class="page-instruction">
    <ng-content select="[instruction]"></ng-content>
  </div>

  <ng-content select="[body]"></ng-content>
</div>
